import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SharedAdminHeader = _resolveComponent("SharedAdminHeader")!
  const _component_AdminKycWrapper = _resolveComponent("AdminKycWrapper")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.b())
  }, [
    _createVNode(_component_SharedAdminHeader, {
      title: "KYC",
      "is-loading": _ctx.isLoading,
      id: _ctx.adminKycHeader.id,
      "onUpdate:id": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.adminKycHeader.id) = $event)),
      type: _ctx.adminKycHeader.type,
      "onUpdate:type": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.adminKycHeader.type) = $event)),
      onSearch: _ctx.handleSearch
    }, null, 8, ["is-loading", "id", "type", "onSearch"]),
    (!!_ctx.isWrapperShow)
      ? (_openBlock(), _createBlock(_component_AdminKycWrapper, {
          key: 0,
          email: _ctx.adminUserAppResponse.user.email,
          id: _ctx.adminUserAppResponse.index,
          type: _ctx.adminUserAppResponse.type
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.displayedComponent), {
              id: _ctx.adminUserAppResponse.user_id,
              component: _ctx.component,
              "onUpdate:component": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.component) = $event))
            }, null, 40, ["id", "component"]))
          ]),
          _: 1
        }, 8, ["email", "id", "type"]))
      : _createCommentVNode("", true),
    (_ctx.isFooterShow)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.displayedFooterComponent), {
          key: 1,
          id: _ctx.adminUserAppResponse.user_id,
          component: _ctx.component,
          "onUpdate:component": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.component) = $event)),
          "is-loading": _ctx.isLoading,
          "onUpdate:isLoading": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.isLoading) = $event)),
          status: _ctx.adminUserAppResponse.status,
          "onUpdate:status": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.adminUserAppResponse.status) = $event)),
          type: _ctx.adminUserAppResponse.type,
          "onUpdate:type": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.adminUserAppResponse.type) = $event))
        }, null, 40, ["id", "component", "is-loading", "status", "type"]))
      : _createCommentVNode("", true)
  ], 2))
}